import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { Box, Typography } from "@mui/material"


export default function AppLegendItem({ idx, icon, label, ...props }) {
	return <Box
		key={`${idx}-${label}`}
		sx={{
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			flexDirection: "column",
			mx: 1,
			flexWrap: "wrap",
		}}>
		<Box sx={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			borderRadius: "5px",
			...props.containerProps
		}}>
			<IconSeeker
				icon={icon}
				tooltip={label}
				iconWeight="light"
				sx={{
					my: .5,
					fontSize: 14,
					...props.iconProps,
				}}
			/>
		</Box>
		<Typography variant="subtitle2" {...props.labelProps}>{label}</Typography>
	</Box>

}